import ApiService from '@/services/common/api.service';
import Utils from '@/helpers/utils';
import { Constants } from "@/helpers/constants";
import _ from 'lodash';

const GroupManagementService = {
    listGroup,
    addGroup,
    deleteGroup,
    getAllDepartments,
    getAllBranchs,
    getAllGroups,
    detailGroup,
    editGroup,
    getAllCompanies,
    getBoxFolders,
};

/*
    List Group
*/
async function listGroup (search, page) {
    let url = '/groups';

    let query = {};

    if (page) {
        query.page = page;
        query.pageSize = Constants.ItemPerpage;
    }

    if (search.companyId) {
        query.companyId = search.companyId;
    }

    if (search.branchId) {
        query.branchId = search.branchId;
    }

    if (search.departmentId) {
        query.departmentId = search.departmentId;
    }

    if (search.groupId) {
        query.groupId = search.groupId;
    }

    if (Utils.isEmptyObj(query) == false) {
        let httpBuildQuery = require('http-build-query');
        url += "?" + httpBuildQuery(query);
    }

    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

/*
    Add Group
*/
async function addGroup (type, params) {
    Utils.trimObject(params);

    let _type = Constants.TypeAdminGroup;

    let url = '/groups';
    let body = {};
    if (type == _type.branch.id) {
        url = '/branchs';

        body.code = _.trim(params.branchCode);
        body.name = _.trim(params.branchName);
        body.company_id = _.trim(params.companyId);
    } else if (type == _type.department.id) {
        url = '/departments';

        body.code = _.trim(params.departmentCode);
        body.name = _.trim(params.departmentName);
        body.branchId = params.branchId;
    } else if (type == _type.group.id) {
        url = '/groups';

        body.code = _.trim(params.groupCode);
        body.name = _.trim(params.groupName);
        body.departmentId = params.departmentId;
    }

    try {
        let response = await ApiService.post(url, body);
        return response;
    } catch (error) {
        return error;
    }
}

/*
    Detail Group
*/
async function detailGroup (id) {
    let url = '/groups/' + id;
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

/*
    Edit Group
*/
async function editGroup (id, params) {
    Utils.trimObject(params);

    let _type = Constants.TypeAdminGroup;

    let url = '/groups';
    let body = {};

    if (id.length == 1) {
        if (params.type == _type.branch.id) {
            url = '/branchs/' + params.branchId;

            body.code = _.trim(params.branchCode);
            body.name = _.trim(params.branchName);
            body.company_id = _.trim(params.companyId);
        } else if (params.type == _type.department.id) {
            url = '/departments/' + params.departmentId;

            body.code = _.trim(params.departmentCode);
            body.name = _.trim(params.departmentName);
            body.branchId = params.branchId;
        } else if (params.type == _type.group.id) {
            url = '/groups/' + params.id;

            body.code = _.trim(params.groupCode);
            body.name = _.trim(params.groupName);
            body.departmentId = params.departmentId;
        }
    } else {
        body.ids = id;
        body.departmentId = params.departmentId;
    }

    try {
        let response = await ApiService.put(url, body);
        return response;
    } catch (error) {
        return error;
    }
}

/*
    Delete Group
*/
async function deleteGroup (ids) {
    let url = '/groups';
    let body = {};

    if (ids.length == 1) {
        url = url + "/" + ids[0];
    } else {
        body.ids = ids;
    }

    let requestData = {
        method: 'DELETE',
        url: url,
        data: body,
    };

    try {
        let response = await ApiService.customRequest(requestData);
        return response;
    } catch (error) {
        return error;
    }
}

/*
    All Group
*/
async function getAllGroups () {
    let url = '/groups?page=all';
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}


/*
    Box Folders By Group
*/
async function getBoxFolders (branchId) {
    let url = '/box-folders?branchId=' + branchId;

    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

/*
    All Departments
*/
async function getAllDepartments () {
    let url = '/departments';
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

/*
    All Branchs
*/
async function getAllBranchs () {
    let url = '/branchs';
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

/*
    All Branchs
*/
async function getAllCompanies () {
    let url = '/companies';
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

export default GroupManagementService;



// WEBPACK FOOTER //
// ./src/services/admin/group.service.js